import { combineReducers } from 'redux';
import genericReducer from './genericReducer';
import dashboardReducer from './dashboardReducer';
import rawProgramReducer from './rawProgramReducer';

const rootReducer = combineReducers({
  genericReducer, dashboardReducer, rawProgramReducer
});

export default rootReducer;

//import users from "./userReducer";
//import authors from "./authorReducer";
//import courses from "./courseReducer";

/*
const rootReducer = combineReducers({
    courses, authors
  });
 */ 
/*
const rootReducer = combineReducers({
    author, course
});
*/




//const rootReducer = courses;
//const rootReducer = userReducer;
//const rootReducer = pingReducer;

/*
export default combineReducers({
    pingReducer
  });
*/